import React from 'react';
import { Github, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

const Projects = () => {
  // ============================================
  // EASY UPDATE SECTION: Your Projects
  // ============================================
  // To add/update projects:
  // 1. Replace 'title' with your project name
  // 2. Replace 'description' with your project description
  // 3. Replace 'image' URL with your project screenshot
  //    (Use https://placehold.co/600x400 for placeholders)
  // 4. Update 'technologies' array with tech used
  // 5. Update 'github' link to your repo
  // 6. Update 'demo' link if you have a live demo
  // ============================================

  const projects = [
    {
      title: 'SEP Revision Test',
      description: 'Created a simple web page to revise for the SEP Certification as well as implemented a dark mode due to not finding similar resources online.',
      image: 'https://placehold.co/600x400/1e293b/BCA4E3?text=SEP+Revision+Test',
      technologies: ['HTML', 'CSS', 'JavaScript'],
      github: 'https://github.com/mikolajwojtowicz/SEP',
      demo: 'https://mikolajwojtowicz.github.io/SEP', // Set to null if no demo available
    },
    {
      title: 'Old Portfolio',
      description: 'Previous iteration of my personal portfolio website.',
      image: 'https://placehold.co/600x400/1e293b/BCA4E3?text=Old+Portfolio+Website',
      technologies: ['HTML', 'CSS', 'JavaScript', 'Vue'],
      github: 'https://github.com/mikolajwojtowicz/portfolio-old',
      demo: 'https://mikolajwojtowicz.github.io/portfolio-old', // Set to null if no demo available
    },
  ];

  return (
    <section id="projects" className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">Projects</h2>
          <div className="w-20 h-1 bg-[#BCA4E3] mx-auto"></div>
        </div>

        <div className={`grid gap-8 ${projects.length === 1
            ? 'grid-cols-1 max-w-md mx-auto'
            : projects.length === 2
              ? 'grid-cols-1 md:grid-cols-2 max-w-3xl mx-auto'
              : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'
          }`}>
          {projects.map((project, index) => (
            <div
              key={index}
              className="bg-slate-800 border border-slate-700 rounded-lg overflow-hidden hover:shadow-xl hover:shadow-[#BCA4E3]/10 hover:border-[#BCA4E3]/30 transition-all duration-300 flex flex-col"
            >
              {/* Project Image */}
              <div className="h-48 overflow-hidden bg-slate-900">
                <img
                  src={project.image}
                  alt={project.title}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Project Content */}
              <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-xl font-semibold text-white mb-3">{project.title}</h3>
                <p className="text-slate-400 mb-4 flex-grow">{project.description}</p>

                {/* Technologies */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.technologies.map((tech, techIndex) => (
                    <span
                      key={techIndex}
                      className="px-3 py-1 bg-slate-900 border border-slate-700 text-slate-300 text-sm rounded-full"
                    >
                      {tech}
                    </span>
                  ))}
                </div>

                {/* Links */}
                <div className="flex gap-3">
                  <Button
                    variant="outline"
                    size="sm"
                    className="flex-1 border-slate-600 text-slate-300 hover:bg-slate-700 hover:text-white"
                    onClick={() => window.open(project.github, '_blank')}
                  >
                    <Github className="w-4 h-4 mr-2" />
                    Code
                  </Button>
                  {project.demo && (
                    <Button
                      size="sm"
                      className="flex-1 bg-[#BCA4E3] hover:bg-[#A88DD6] text-slate-900 font-semibold"
                      onClick={() => window.open(project.demo, '_blank')}
                    >
                      <ExternalLink className="w-4 h-4 mr-2" />
                      Demo
                    </Button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
